import { qs } from '../qs'
const BASE_PATH = '/aqi/forecast'

export default {
  getNewDate: () => ({
    url: `${BASE_PATH}/new/date`,
    method: 'GET'
  }),
  getHeightData: query => ({
    url: `${BASE_PATH}/height${qs(query, '?')}`,
    method: 'GET'
  }),
  getDayData: query => ({
    url: `${BASE_PATH}/data/day${qs(query, '?')}`,
    method: 'GET'
  }),
  getHourData: query => ({
    url: `${BASE_PATH}/data/hour${qs(query, '?')}`,
    method: 'GET'
  })
}



// WEBPACK FOOTER //
// ./src/apis/modules/Forecast.js